import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import parseChangelog from "changelog-parser";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ChangeCategory } from "src/app/models/changelog/ChangeCategory";
import { Changelog } from "src/app/models/changelog/Changelog";
import { ChangelogType } from "src/app/models/Enums";
import { FileService } from "src/app/services/file.service";
import { ModalComponent } from "src/app/services/modal.service";

@Component({
  selector: "changelog-modal",
  templateUrl: "./changelog-modal.component.html",
  styleUrls: ["./changelog-modal.component.scss"],
  standalone: false,
})
export class ChangelogModalComponent
  implements OnInit, ModalComponent<ChangelogModalComponent, void, boolean>
{
  readonly localizationConstants = LocalizationConstants;

  private changelogFilePath = "/assets/CHANGELOG.md";
  title: string = "";
  content: string[] = [];
  requestId: string;
  additionalDetails: string[];
  changelog: Changelog;

  constructor(
    public dialogRef: MatDialogRef<ChangelogModalComponent, boolean>,
    private fileService: FileService,
  ) {}

  async ngOnInit() {
    const changelogStr = await this.getChangelogContentAsync();
    parseChangelog({ text: changelogStr }, (error: Error, result: Changelog) => {
      if (error) {
        throw error;
      }

      this.changelog = new Changelog().deserialize(result);
    });
  }

  onClose() {
    this.dialogRef.close(false);
  }

  private async getChangelogContentAsync(): Promise<string> {
    const changelogStr = await this.fileService.readFile(this.changelogFilePath).toPromise();

    return changelogStr;
  }

  public getChangelogCategoryIcon(log: ChangeCategory): string {
    switch (log.title) {
      case ChangelogType.Added:
        return "data-enrichment--add";
      case ChangelogType.Changed:
        return "status--change";
      case ChangelogType.Deprecated:
        return "outage";
      case ChangelogType.Fixed:
        return "tools";
      case ChangelogType.Removed:
        return "trash-can";
      case ChangelogType.Security:
        return "password";
    }
  }
}
